import "@@/core/assets/css/print.css";
import { Printd } from "printd";
import configProvider from "@@/core/configProvider";
import styles from "./GetStyles";
import VueBarcode from "vue-barcode";

export default {
    name: "HavaleBarcode",
    components: {
        barcode: VueBarcode,
    },
    data() {
        return {
            varieties: [],
        };
    },
    props: {  
        varieties: {  
            type: String,  
            required: true  
        }  
    },  
    computed: {  
        parsedVarieties() {
            return JSON.parse(this.varieties || '[]'); 
        }  
    },  
    mounted() {
        try {
            const stored = localStorage.getItem('barcodeVarieties');
            this.varieties = stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error('خطا در خواندن داده‌ها از localStorage:', e);
            this.varieties = [];
        }
    },
    methods: {
        formatPrice(price) {  
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
        }, 
        extractColor(text) {
            const parts = text.split('|');
            if (!parts[1]) {
                return parts[0];
            }else{
                return parts[1]?.trim() || '';
            }
        },
        adjustHeight(event) {  
            event.target.style.height = 'auto';
            event.target.style.height = `${event.target.scrollHeight}px`; 
        }, 
        print() {
            const d = new Printd();
            let _styles;
            if (configProvider.get("print_font")) {
                _styles =
                styles +
                "@font-face{font-family:'yekan-bakh';src:url(" +
                configProvider.get("print_font") +
                ") format('woff');font-weight:normal;font-style:normal;}";
            } else {
                _styles = styles;
            }
            d.print(document.getElementById("print"), [_styles]);
        },
        checkLabel(key) {
            if (key.includes("tarh")) {
                return "tarh:";
            } else if (key.includes("color")) {
                return "color:";
            } else if (key.includes("size")) {
                return "size:";
            } else {
                return "model:";
            }
        },
        async getVarieties(varieties) {
            let params = {};
            varieties.split(",").forEach((id, index) => {
                params[`ids[${index}]`] = id;
            });
            const response = await this.$axios(`admin/products_excels`, {
                params: params,
            });
            this.varieties.push(...response.data.data.data);
            if (this.$route.query.variety) {
                let finded = this.varieties.find((v) => {
                return v[6] == this.$route.query.variety;
                });
                this.varieties = [];
                this.varieties.push(finded);
            }
            this.$forceUpdate();
        },
    },
};
